module.exports = __webpack_public_path__ + "img/portrait-081.80f97004.jpg";